module.exports = __webpack_public_path__ + "static/media/02EchoMountainmuralinitiallayout.4f9ce0f8.webp";